import { commaFormat } from "@p-ban/common/src/utils/NumberUtils"

import type { TotalResult } from "../../../../types/parsedResult"
import ArrivalDate from "./ArrivalDate"
import { NumberAndUnit } from "./NumberAndUnit"
import { MdOutlineDescription } from "react-icons/md"
import { Button } from "../../../../../../shadcn/Button"

type Props = {
  result?: Extract<TotalResult, { isIndividual: false }>
  openEstimateDetail?: () => void
}

const PeriodAndAmount = ({ result, openEstimateDetail }: Props) => {
  return (
    <div>
      <div className="mb-1 flex items-end justify-between">
        <NumberAndUnit
          title="実働"
          number={result?.days ?? "-"}
          unit="日"
          containerClassName="w-[64px]"
          valueClassName="w-16 mr-2.5"
        />
        <NumberAndUnit
          title="合計金額"
          number={result ? commaFormat(result.amountWithoutTax) : "-"}
          unit="円"
          containerClassName="w-[184px]"
          valueClassName="w-[184px]"
        />
        <Button
          variant="ghost"
          size="icon"
          onClick={openEstimateDetail}
          className="bg-brand-common-white h-8 w-8 rounded-2xl shadow-md"
        >
          <MdOutlineDescription className="size-6 text-[#16A34A]" />
        </Button>
      </div>
      {result && (
        <div className="mb-2 w-full px-[42px] text-right text-xs text-[#333333]">
          税込 {commaFormat(result.amount)} 円
        </div>
      )}
      <ArrivalDate date={result?.arrivalDate} orderLimit={result?.orderLimit} />
    </div>
  )
}

export default PeriodAndAmount
